import { useCollection, useCollections } from "@/api/hooks";
import {
  useAddChildCollectionMutation,
  useRemoveChildCollectionMutation,
} from "@/api/api";
import CollectionsCombobox from "./CollectionsCombobox";

export default function CollectionChildrenCombobox() {
  const collection = useCollection();

  const allowedChildrenCollections = useCollections(
    collection?.allowed_children,
  );
  const [addChildCollection] = useAddChildCollectionMutation();
  const [removeChildCollection] = useRemoveChildCollectionMutation();

  if (!collection || !allowedChildrenCollections) return null;

  const handleChange = (collections: string[]) => {
    const collectionsToRemove = collection.child_ids.filter(
      (colID) => !collections.includes(colID),
    );

    const collectionsToAdd = collections.filter(
      (collectionID) => !collection.child_ids.includes(collectionID),
    );

    if (collectionsToAdd.length > 0) {
      addChildCollection({
        parentID: collection.id,
        childIDs: collectionsToAdd,
      });
    }

    if (collectionsToRemove) {
      removeChildCollection({
        parentID: collection.id,
        childIDs: collectionsToRemove,
      });
    }
  };

  return (
    <CollectionsCombobox
      label="Children collections"
      allCollections={allowedChildrenCollections}
      value={collection.child_ids}
      onChange={handleChange}
    />
  );
}
